import { Theme } from "@emotion/react";
import { TextField, TextFieldProps as MuiTextFieldProps, SxProps, Radio, TextFieldPropsSizeOverrides, InputAdornment } from '@mui/material';
import React, { ChangeEventHandler, InputEventHandler } from "react";
import { IMaskInput } from "react-imask";

interface TextFieldProps {
    id: string;
    label?: string;
    sx?: SxProps<Theme>;
    variant?: MuiTextFieldProps['variant'];
    type?: string;
    disabled?: boolean;
    error?: boolean;
    defaultValue?: string;
    helperText?: string;
    onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onInput?: InputEventHandler<HTMLDivElement>;
    value?: string;
    fullWidth?: boolean;
    placeholder?: string;
    disableUnderline?: boolean;
    rows?: number;
    multiline?: boolean;
    required?: boolean;
    maskTelefone?: boolean;
    checked?: boolean;
    FormHelperTextProps?: any;
    size?: MuiTextFieldProps['size'];
    maskDinheiro?: boolean
    maxRows?: number
}

const TextFieldComponent = (props: TextFieldProps) => {
    if (props.maskTelefone) {
        return (
            <TextField
                id={props.id}
                label={props.label}
                variant={props.variant}
                sx={props.sx}
                disabled={props.disabled}
                error={props.error}
                defaultValue={props.defaultValue}
                helperText={props.helperText}
                fullWidth={props.fullWidth}
                placeholder={props.placeholder}
                rows={props.rows}
                multiline={props.multiline}
                value={props.value}
                onChange={props.onChange}
                required={props.required}
                slotProps={{
                    input: {
                        inputComponent: IMaskInput as any,
                        inputProps: {
                            mask: "(00) 00000-0000",
                        },
                        disableUnderline: props.disableUnderline,
                    },
                }}
                size={props.size}
                maxRows={props.maxRows}
            />
        );
    }

    if (props.maskDinheiro) {
        return <TextField
            id={props.id}
            label={props.label}
            variant={props.variant}
            sx={props.sx}
            disabled={props.disabled}
            error={props.error}
            defaultValue={props.defaultValue}
            helperText={props.helperText}
            fullWidth={props.fullWidth}
            placeholder={props.placeholder}
            rows={props.rows}
            multiline={props.multiline}
            value={props.value}
            onChange={props.onChange}
            required={props.required}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            R$
                        </InputAdornment>
                    ),
                    inputComponent: IMaskInput as any,
                    inputProps: {
                        mask: Number,
                        scale: 2,
                        radix: ',',
                        thousandsSeparator: '.',
                        padFractionalZeros: true,
                        normalizeZeros: true,
                    }
                }
            }}
            size={props.size}
            maxRows={props.maxRows}
        />
    }

    if (props.type === "radio") {
        return <Radio
            id={props.id}
            checked={props.checked}
            onChange={props.onChange}
            value={props.checked}
        />
    }

    return <TextField
        id={props.id}
        label={props.label}
        type={props.type}
        variant={props.variant}
        sx={props.sx}
        disabled={props.disabled}
        error={props.error}
        defaultValue={props.defaultValue}
        helperText={props.helperText}
        onChange={props.onChange}
        onInput={props.onInput}
        value={props.value}
        fullWidth={props.fullWidth}
        placeholder={props.placeholder}
        rows={props.rows}
        multiline={props.multiline}
        required={props.required}
        slotProps={{
            input: {
                disableUnderline: props.disableUnderline,
            },
        }}
        FormHelperTextProps={props.FormHelperTextProps}
        size={props.size}
        maxRows={props.maxRows}
    />
}

export default TextFieldComponent;